const Press = ({ data }) => (
  <section className="relative mid-gray">
    <h2 className="sr-only">Press Reviews</h2>
    <Img
      sizes={data.image.childImageSharp.sizes}
      alt=""
      className="fill"
      style={{ position: `absolute`, zIndex: `-1` }}
    />

    <Slider data={data.reviews} layout={SlideLayout} settings={slickSettings} />
  </section>
)

export default Press

/*
 *
 * General
 * 
 */

import React from 'react'

import Img from '../components/base/Img'
import Slider from '../components/Slider'

/*
 *
 * Slide Layout
 * 
 */

const SlideLayout = ({ slide }) => (
  <blockquote className="container pv5 tc">
    <p
      dangerouslySetInnerHTML={{ __html: slide.quotation }}
      className="ml-auto mr-auto mb3 measure-narrow lh-copy f4 ttu"
    />
    <cite className="db mb2 f5 fs-normal ttu">{slide.source}</cite>
    <div aria-hidden="true" className="ml-auto mr-auto bw2 bt-0 b--purple w3" />
  </blockquote>
)

/*
 *
 * Slick Settings
 * 
 */

const slickSettings = {
  arrows: false,
  autoplay: true,
  autoplaySpeed: 5000,
  // dots: true,
  fade: true,
  infinite: true,
  lazyload: `progressive`,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1
}



// WEBPACK FOOTER //
// ./src/sections/Press.js